import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TEmailABTestVariation } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import { getEmailABTestVersionLabel } from '@feathr/extender/utils/emailABTest';

interface IProps {
  variation: TEmailABTestVariation;
}

function EmailABTestVersionPill({ variation }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Pill showPrefix={false} truncate={false}>
      {getEmailABTestVersionLabel(variation, t)}
    </Pill>
  );
}

export default EmailABTestVersionPill;
